<template>
    <div class="container" v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">Dental Accounting Assessment Test</h1>
                    </div>
                    <el-form :model="form" ref="form" :rules="rules">
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=3" :src="wrong"></el-image>
                                1) One of the advantages of a Quickbooks Online subscription of<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                                <!-- 答案第三个 -->
                            <el-form-item prop="sub0" ref="sub0">
                                <el-radio-group v-model="form.sub0" :disabled="isAdmin">
                                    <el-radio :label="0">Unlimited user access</el-radio><br>
                                    <el-radio :label="1">LIFO Inventory valuation</el-radio><br>
                                    <el-radio :label="2">Document Management System</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">All data is hosted , backed up and secured by Intuit's serversn 4</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub0!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=3" :src="wrong"></el-image>
                                2) Which of the following helps accounting professionals save time when using QuickBooks Online Accountant?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub1" ref="sub1">
                                <el-radio-group v-model="form.sub1" :disabled="isAdmin">
                                    <el-radio :label="0">Free online tax software</el-radio><br>
                                    <el-radio :label="1">Free apps for Accountants only</el-radio><br>
                                    <el-radio :label="2">Automated time tracking for hours worked in each client file</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">One-click access to clients' books and payroll to take immediate action.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub1!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=3" :src="wrong"></el-image>
                                3) Where can you access Downloaded Transactions in QuickBooks Online? <span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub2" ref="sub2">
                                <el-radio-group v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">Quick Create>Other</el-radio><br>
                                    <el-radio :label="1">Tools menu>Banking</el-radio><br>
                                    <el-radio :label="2">Quick Create>Banking</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Transactions>Banking</el-radio>
                                        <el-image v-if="isAdmin&&form.sub2!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=0" :src="wrong"></el-image>
                                4) Which of the following items can users do from the Setup Wizard within QuickBooks Online?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub3" ref="sub3" >
                                <el-radio-group v-model="form.sub3" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Import QuickBooks Desktop Data</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub3!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Review Previous reconciliation reports</el-radio><br>
                                    <el-radio :label="2">Customize the left-side navigation manu</el-radio><br>
                                    <el-radio :label="3">Change the color scheme of QuickBooks Online</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=0" :src="wrong"></el-image>
                                5) Where do you find accounting related preferences?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub4" ref="sub4">
                                <el-radio-group v-model="form.sub4" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Gear Icon/Company Setting</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub4!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Accountant Toolbar/Accounting Settings</el-radio><br>
                                    <el-radio :label="2">Accountant Center/Accounting Settings</el-radio><br>
                                    <el-radio :label="3">Alerts/Change Preferences</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=2" :src="wrong"></el-image>
                                6) Which of the following is a step to merge two accounts together in the chart of accounts?<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub5" ref="sub5">
                                <el-radio-group v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">Deactivate the old account</el-radio><br>
                                    <el-radio :label="1">Change the company preferences</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Edit one account and name it exactly as the other</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub5!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Add new account and reclassify all transactions to the new account</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=1" :src="wrong"></el-image>
                                7) If there is an amount under the Change column on the Reconciliation History screen, it means:<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub6" ref="sub6">
                                <el-radio-group v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">Client deleted bank reconciliation</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Client changed an already reconciled transaction</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub6!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Client forced the bank reconciliation</el-radio><br>
                                    <el-radio :label="3">Client hasn't reconciled the account</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=1" :src="wrong"></el-image>
                                8) What is the best definition of a transfer:<span class="required">*</span></div>
                                <div class="score" >1 points</div>
                            <el-form-item prop="sub7" ref="sub7">
                                <el-radio-group v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">Paying a vendor via ACH</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Moving money from one company account to another</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub7!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Accepting payments from a customer via ACH</el-radio><br>
                                    <el-radio :label="3">Moving money from company to owner</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=2" :src="wrong"></el-image>
                                9) What is one of the main benefits to using QuickBooks Online Reports?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub8" ref="sub8">
                                <el-radio-group v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">Manage Accounts Payable</el-radio><br>
                                    <el-radio :label="1">Diagnose data entry reports</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Quickly access financial information</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub8!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Locate Accounts Receivable discrepancies</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=0" :src="wrong"></el-image>
                                10) You are helping your client re-design their Chart of Accounts for more streamlined reporting. Which of the following would you need to set up in order to establish a hierarchy view?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub9" ref="sub9">
                                <el-radio-group v-model="form.sub9" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Subaccounts</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub9!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Account Listing</el-radio><br>
                                    <el-radio :label="2">Category Types</el-radio><br>
                                    <el-radio :label="3">Company "Snapshot"</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=2" :src="wrong"></el-image>
                                11) Where should you look to quickly identify potential Accounts Receivable errors in QuickBooks Online?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub10" ref="sub10">
                                <el-radio-group v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">Customer Center</el-radio><br>
                                    <el-radio :label="1">Deposit Detair Report</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">A/R Aging Detail Report</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub10!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Transaction List by Customer Report</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=3" :src="wrong"></el-image>
                                12) Your client recorded a check in the prior fiscal year that did not clear and was re-issued in the current fiscal year.  The best way to repair this issue is: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub11" ref="sub11">
                                <el-radio-group v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0"> Delete/void the check from the prior fiscal year and create new check in the current year</el-radio><br>
                                    <el-radio :label="1">Change the date and the check number of the original check entered in the prior fiscal year to match the new check number and date</el-radio><br>
                                    <el-radio :label="2">Delete the check and re-enter as a bill payment using the same check number and date originally used</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Create a deposit to the same expense account as the original check but dates in the current period, then reconcile them against each other.</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub11!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=3" :src="wrong"></el-image>
                                13) You have a client who uses a local credit union that does not sync with QuickBooks Online.  The best way to get the transactions into QuickBooks online is:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub12" ref="sub12">
                                <el-radio-group v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">Hand key transactions into the account register</el-radio><br>
                                    <el-radio :label="1">Download and import a Direct Connect File with the Import Data tool</el-radio><br>
                                    <el-radio :label="2">Download and import an ILF file with the Import Data tool</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Download and import a .qbo file through the Transaction window</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub12!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=1" :src="wrong"></el-image>
                                14) A bank connection error has occurred and you need to disconnect/reconnect a feed.  Which occurrence below will happen when you disconnect/reconnect the feed: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub13" ref="sub13">
                                <el-radio-group v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">You will have to setup a new account in the chart of accounts to map the feed to</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Transactions will begin downloading as of the date that you reset the connection</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub13!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Unposted transactions remaining in the downloaded transaction window will disappear</el-radio><br>
                                    <el-radio :label="3">90 days of transactions will download and will match to existing downloaded transactions if they are duplicates</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=2" :src="wrong"></el-image>
                                15) Some transactions were downloaded from the bank and matched to the wrong transactions existing in the account register. The best way to work with these transactions:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub14" ref="sub14">
                                <el-radio-group v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">Delete the transaction from the register and re-post</el-radio><br>
                                    <el-radio :label="1">"Exclude" the transactions from the downloaded transactions window</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">"Undo" the transactions from the "In QuickBooks" tab in the transactions window</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub14!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Re-download the transactions from the bank and re-post them to the proper account.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=2" :src="wrong"></el-image>
                                16) When going in to reconcile a bank account and the beginning balance does not match the statement. Where can you view account's reconciled period? <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub15" ref="sub15">
                                <el-radio-group v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">Chart of accounts</el-radio><br>
                                    <el-radio :label="1">Reconciliation Report</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Reconciliation History</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub15!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Banking Changes screen</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=2" :src="wrong"></el-image>
                                17) Your client has categorized all payments to a particular vendor as Office Rent; they should have been categorized as Utilities. Which Accountant tool is useful to remedy this issue?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub16" ref="sub16">
                                <el-radio-group v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">Adjusting Journal Entries</el-radio><br>
                                    <el-radio :label="1">Undo Bank Reconcliation</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Reclassify Transactions</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub16!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Write off invoices in a batch</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=2" :src="wrong"></el-image>
                                18) Which of the following is a liability account?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub17" ref="sub17">
                                <el-radio-group v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">Retained Earnings</el-radio><br>
                                    <el-radio :label="1">Prepaid Rent</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Unearned Revenue</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub17!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Accumulated Depreciation</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=0" :src="wrong"></el-image>
                                19) If, at year end, the accounting records show the data below, what is total owner’s equity?  
                                Total assets $500,000   
                                Total liabilities 200,000   
                                Revenue 400,000   
                                Expense 170,000 <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub18" ref="sub18">
                                <el-radio-group v-model="form.sub18" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">$300,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub18!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">$230,000</el-radio><br>
                                    <el-radio :label="2">$70,000</el-radio><br>
                                    <el-radio :label="3">$530,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=2" :src="wrong"></el-image>
                                20) On December 31, 2007, your firm borrows $10,000 from the Ajax Bank, signing a 6-month note at 8% interest per year. How do you record this transaction?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub19" ref="sub19">
                                <el-radio-group v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">Cash 9,600;  Notes Payable 9,600</el-radio><br>
                                    <el-radio :label="1">Cash 10,000,  Interest expense 400;  Notes payable 10,400</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Cash 10,000;  Notes payable 10,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub19!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Cash 10,00, Interest Expense 400;   Notes payable 10,00, Interest payable 400</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=3" :src="wrong"></el-image>
                                21) The following information was gathered while reconciling the bank statement:                               
                                * Deposits in transit amounted to $6,700                     
                                * Bank charges amounted to $75                             
                                * A $250 check deposited in the bank was returned marked “NSF”   
                                * Checks outstanding amounted to $3,300Assuming these are the only adjustments in the bank reconciliation, what is the net (total)adjustment to the balance per bank?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub20" ref="sub20">
                                <el-radio-group v-model="form.sub20" :disabled="isAdmin">
                                    <el-radio :label="0">$10,325</el-radio><br>
                                    <el-radio :label="1">$6,700</el-radio><br>
                                    <el-radio :label="2">$3,400</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">$325</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub20!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=3" :src="wrong"></el-image>
                                22) The following information was established while reconciling the bank statement:
                                * Deposits in transit amounted to $6,700                  
                                * Bank charges amounted to $75                            
                                * A $250 check deposited in the bank was returned marked “NSF”                                               
                                * Checks outstanding amounted to $3,300 Assuming these are the only adjustments in the bank reconciliation, what is the net (total)adjustment to the balance per books?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub21" ref="sub21">
                                <el-radio-group v-model="form.sub21" :disabled="isAdmin">
                                    <el-radio :label="0">$10,325</el-radio><br>
                                    <el-radio :label="1">$6,700</el-radio><br>
                                    <el-radio :label="2">$3,400</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">$325</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub21!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=3" :src="wrong"></el-image>
                                23) Your accrual-basis company holds a $48,000, 10% note receivable with interest payable annually on June 30. If your company’s fiscal year ends on August 31, what adjusting journal entry do you record?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub22" ref="sub22">
                                <el-radio-group v-model="form.sub22" :disabled="isAdmin">
                                    <el-radio :label="0">Interest Receivable 4,800; Interest Revenue 4,800</el-radio><br>
                                    <el-radio :label="1">Interest Receivable 4,400; Interest Revenue 4,400</el-radio><br>
                                    <el-radio :label="2">Interest Receivable 480; Interest Revenue 480</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Interest Receivable 800;  Interest Revenue 800</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub22!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=1" :src="wrong"></el-image>
                                24) Your firm, which is on the accrual basis, has a $100,000 Monday-Friday weekly payroll, and Friday is payday. If the year ends on a Tuesday, what adjusting journal entry will you record?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub23" ref="sub23">
                                <el-radio-group v-model="form.sub23" :disabled="isAdmin">
                                    <el-radio :label="0">Salaries Expense 100,000; Salaries Payable 100,000</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Salaries Expense 40,000; Salaries Payable 40,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub23!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Salaries Expense 80,000; Salaries Payable 80,000</el-radio><br>
                                    <el-radio :label="3">Salaries Expense 20,000; Salaries Payable 20,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=0" :src="wrong"></el-image>
                                25) Your law firm, which is on the accrual basis, signs a one-year retainer for $12,000, payable monthly, and receives a $3,000 advance, crediting Deferred Revenue. If, at year end, one month has elapsed, what adjusting entry would you record?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub24" ref="sub24">
                                <el-radio-group v-model="form.sub24" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Deferred Revenue 1,000; Revenue 1,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub24!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Deferred Revenue 2,000; Revenue 2,000</el-radio><br>
                                    <el-radio :label="2">Revenue 1,000; Deferred Revenue 1,000</el-radio><br>
                                    <el-radio :label="3">Cash 3,000; Revenue 3,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub25!=1" :src="wrong"></el-image>
                                26) Your company, which is on the accrual basis, prepays $24,000 for 1 year’s insurance premiums and debits Insurance Expense. If, 3 months later, your firm's year ends, what adjusting entry do you record?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub25" ref="sub25">
                                <el-radio-group v-model="form.sub25" :disabled="isAdmin">
                                    <el-radio :label="0">Insurance Expense 18,000; Prepaid Insurance 18,000</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Prepaid Insurance 18,000; Insurance Expense 18,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub25!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Insurance Expense 6,000; Prepaid Insurance 6,000</el-radio><br>
                                    <el-radio :label="3">Prepaid Insurance 6,000; Insurance Expense 6,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub26!=1" :src="wrong"></el-image>
                                27) On May 11, your calendar year firm incurs and records advertising expense of $700 as follows:             
                                Advertising Expense 700                             
                                Accounts Payable 700                                            
                                On June 6 of the same year your firm pays the $700 and records the payment as follows:                                   
                                Advertising Expense 700  Cash 700                       
                                To correct the error, you will debit: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub26" ref="sub26">
                                <el-radio-group v-model="form.sub26" :disabled="isAdmin">
                                    <el-radio :label="0">Cash for $700</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Accounts Payable for $700</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub26!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Advertising Expense for $700</el-radio><br>
                                    <el-radio :label="3">Prepaid Advertising for $700</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub27!=0" :src="wrong"></el-image>
                                28) If employee Alice is paid $10 an hour and recorded the following hours for the workweek, what are her gross wages for the workweek under federal law? Hours on the job 36 Commuting between home and the job site 10 Lunch hours 5 Total hours 51<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub27" ref="sub27">
                                <el-radio-group v-model="form.sub27" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">$360</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub27!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">$410</el-radio><br>
                                    <el-radio :label="2">$412</el-radio><br>
                                    <el-radio :label="3">$510</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub28!=0" :src="wrong"></el-image>
                                29) What should an employer do when an employee marries and changes her name?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub28" ref="sub28">
                                <el-radio-group v-model="form.sub28" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Obtain a new W-4 which should be implemented within 30 days only if the employee submits a new Social Security card showing the new name</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub28!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Obtain a new W-4 which should be implemented within 30 days regardless of whether the  employee submits a new Social Security card showing the new name</el-radio><br>
                                    <el-radio :label="2">Immediately change the employee’s name on the payroll system; neither a new W-4 nor a new Social Security card is as important as putting the proper name in the payroll system</el-radio><br>
                                    <el-radio :label="3">Change the employee’s name on the payroll system only if the employee requests it; neither a new W-4 nor a new Social Security card is required</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub29!=2" :src="wrong"></el-image>
                                30) If you do not get a Taxpayer Identification Number (TIN) from independent contractor Joan who earns $5,000 from your company in 2005, your company must:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub29" ref="sub29">
                                <el-radio-group v-model="form.sub29" :disabled="isAdmin">
                                    <el-radio :label="0">Provide Joan with a 1099-MISC reporting the $5,000</el-radio><br>
                                    <el-radio :label="1">Provide Joan with a 1099-MISC reporting the $5,000 and withholding federal income tax as you would for an employee</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">1099-MISC reporting the $5,000 and withholding federal income tax at the year 2005 backup tax rate of 28%</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub29!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Withhold all payments from Joan until she gives you her TIN</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub30!=2" :src="wrong"></el-image>
                                31) Which of the following accounts is increased by a debit?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub30" ref="sub30">
                                <el-radio-group v-model="form.sub30" :disabled="isAdmin">
                                    <el-radio :label="0">Accumulated Depreciation</el-radio><br>
                                    <el-radio :label="1">Federal Income Tax Withheld</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Prepaid Insurance</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub30!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Unearned Revenue</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub31!=1" :src="wrong"></el-image>
                                32) You firm uses the allowance method for bad debt expense. When, on May 6, you receive confirmation that Customer A is bankrupt and its $400 account receivable is worthless, you will:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub31" ref="sub31">
                                <el-radio-group v-model="form.sub31" :disabled="isAdmin">
                                    <el-radio :label="0">Debit Bad Debt Expense for $400</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Debit Allowance For Doubtful Accounts for $400</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub31!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Debit Accounts Receivable for $400</el-radio><br>
                                    <el-radio :label="3">Credit Allowance For Doubtful Accounts for $400</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub32!=0" :src="wrong"></el-image>
                                33) The bank erroneously deducted a check written by Post Company from Board Company’s account. In Board Company’s bank reconciliation, the amount of this check should be:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub32" ref="sub32">
                                <el-radio-group v-model="form.sub32" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Added to the balance per bank</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub32!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Deducted from the balance per bank</el-radio><br>
                                    <el-radio :label="2">Added to the balance per books</el-radio><br>
                                    <el-radio :label="3">Deducted from the balance per books</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub33!=3" :src="wrong"></el-image>
                                34) When a customer’s check marked “NSF” is returned, the amount of the check is: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub33" ref="sub33">
                                <el-radio-group v-model="form.sub33" :disabled="isAdmin">
                                    <el-radio :label="0">Added to the balance per bank in a bank reconciliation</el-radio><br>
                                    <el-radio :label="1">Deducted from the balance per bank in a bank reconciliation</el-radio><br>
                                    <el-radio :label="2">Added to the balance per books in a bank reconciliation</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="3">Deducted from the balance per books in a bank reconciliation</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub33!=3" class="rightPic" :src="right"></el-image>
                                    </div>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub34!=1" :src="wrong"></el-image>
                                35) Your calendar year company, which is on the accrual basis, pays sales reps a 5% commission onsales. If, as of December 31, your sales for the year are $1 million, and you have paid $44,000 in commissions, you will: <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub34" ref="sub34">
                                <el-radio-group v-model="form.sub34" :disabled="isAdmin">
                                    <el-radio :label="0">Debit Commission Expense for $44,000</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="1">Debit Commission Expense for $6,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub34!=1" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="2">Credit Commissions Payable for $5,000</el-radio><br>
                                    <el-radio :label="3">Credit Commissions Payable for $50,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub35!=0" :src="wrong"></el-image>
                                36) Your accrual-basis firm begins business this year, buying $15,000 of office supplies and debiting Supplies Expense. If, at year-end, $9,000 of supplies are on hand, what adjusting entry do you record? <span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub35" ref="sub35">
                                <el-radio-group v-model="form.sub35" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Office Supplies On Hand 9,000; Office Supplies Expense 9,000</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub35!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Office Supplies On Hand 6,000; Office Supplies Expense 6,000</el-radio><br>
                                    <el-radio :label="2">Office Supplies Expense 6,000; Cash 6,000</el-radio><br>
                                    <el-radio :label="3">Office Supplies On Hand 15,000; Office Supplies Expense 15,000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                       <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub36!=2" :src="wrong"></el-image>
                                37) On May 7, your firm incurs $200 in office expenses, which it pays right away, but fails to record. If, you discover the error a week later, what entry would you record to correct it?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub36" ref="sub36">
                                <el-radio-group v-model="form.sub36" :disabled="isAdmin">
                                    <el-radio :label="0">Accounts Payable 200; Cash 200</el-radio><br>
                                    <el-radio :label="1">Cash 200; Office Expense 200</el-radio><br>
                                    <div class="review">
                                        <el-radio :label="2">Office Expense 200; Cash 200</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub36!=2" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="3">Office Expense 200; Accounts Payable 200</el-radio>
                                </el-radio-group>
                            </el-form-item>
                       </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub37!=0" :src="wrong"></el-image>
                                38) Your company has a $200 petty cash fund from which the petty cash custodian reimburses an employee $7 for gasoline. When you replenish the fund, you will:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub37" ref="sub37">
                                <el-radio-group v-model="form.sub37" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Debit Gasoline Expense for $7</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub37!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Debit Petty Cash Expense for $7</el-radio><br>
                                    <el-radio :label="2">Make no journal entry</el-radio><br>
                                    <el-radio :label="3">Credit Petty Cash for $7</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub38!=0" :src="wrong"></el-image>
                                39) Which of the following statements about the cash disbursements journal is true?<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub38" ref="sub38">
                                <el-radio-group v-model="form.sub38" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Each entry in the cash disbursements journal will be a credit to the ledger Cash account</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub38!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">The cash disbursements journal is used to record revenue transactions</el-radio><br>
                                    <el-radio :label="2">The cash disbursements journal has a T-account for each asset, liability and equity account</el-radio><br>
                                    <el-radio :label="3">A cash disbursements journal is not used if the firm is on the accrual basis</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub39!=0" :src="wrong"></el-image>
                                40) The Income Summary account contains:<span class="required">*</span></div>
                            <div class="score" >1 points</div>
                            <el-form-item prop="sub39" ref="sub39">
                                <el-radio-group v-model="form.sub39" :disabled="isAdmin">
                                    <div class="review">
                                        <el-radio :label="0">Total revenues and total expenses for the year</el-radio><br>
                                        <el-image v-if="isAdmin&&form.sub39!=0" class="rightPic" :src="right"></el-image>
                                    </div>
                                    <el-radio :label="1">Total assets and total liabilities at year end</el-radio><br>
                                    <el-radio :label="2">Total revenues, expenses, assets, and liabilities at year end</el-radio><br>
                                    <el-radio :label="3">Total revenues and assets at year end</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="btnLayout" style="margin:0 0 10px 5px">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel"  v-if="!isAdmin">Cancel</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">Dental Accounting Assessment Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                    <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                    <span>Thank you for completing this knowledge assessment!</span><br/>
                    <span>Please allow up to three business days while we review your application.</span>
                    <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name:'dentalAccountingTest',
        components:{ApplyHeader,Side},
        data(){
            return {
                totalNum:40,
                correctNum:0,
                confirmVisible:false,
                exitVisible:false,
                loading:false,
                showResult:false,
                hasFinished:false,
                wrong:wrong,
                right:right,
                isAdmin:false,
                form:{
                    sub0:'',
                    sub1:'',
                    sub2:'',
                    sub3:'',
                    sub4:'',
                    sub5:'',
                    sub6:'',
                    sub7:'',
                    sub8:'',
                    sub9:'',
                    sub10:'',
                    sub11:'',
                    sub12:'',
                    sub13:'',
                    sub14:'',
                    sub15:'',
                    sub16:'',
                    sub17:'',
                    sub18:'',
                    sub19:'',
                    sub20:'',
                    sub21:'',
                    sub22:'',
                    sub23:'',
                    sub24:'',
                    sub25:'',
                    sub26:'',
                    sub27:'',
                    sub28:'',
                    sub29:'',
                    sub30:'',
                    sub31:'',
                    sub32:'',
                    sub33:'',
                    sub34:'',
                    sub35:'',
                    sub36:'',
                    sub37:'',
                    sub38:'',
                    sub39:'',
                },
                rules:{
                    sub0:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub1:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub2:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub3:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub4:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub5:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub6:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub7:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub8:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub9:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub10:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub11:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub12:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub13:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub14:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub15:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub16:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub17:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub18:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub19:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub20:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub21:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub22:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub23:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub24:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub25:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub26:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub27:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub28:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub29:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub30:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub31:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub32:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub33:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub34:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub35:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub36:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub37:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub38:[{ required: true, message: 'Required', trigger: 'blur' },],
                    sub39:[{ required: true, message: 'Required', trigger: 'blur' },],
                }
            }
        },
        mounted(){
            this.getData()
        },
        computed:{
            getHeight(){
                return document.documentElement.clientHeight
            },
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                let per = Number(100*this.correctNum/this.totalNum).toFixed(2)
                return per+'%'
            },
        },
        methods:{
            goPre(){
                this.$router.go(-1)
            },
            getUserAnswerData(id,email){
                console.log('id',id);
                console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data!=null){
                            var list = res.data.detail
                            for(var i=0;i<list.length;i++){
                                this.$set(this.form,('sub'+i),list[i])
                            }
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                     var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            cancel(){
                this.exitVisible=true
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            submit(){
                this.confirmVisible = false
                var score=0
                var list=[]
                var len = Object.keys(this.form).length
                for(var i=0;i<len;i++){
                    list.push(this.form['sub'+i])
                }
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 40
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                console.error('传值是',params)
                // return
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.goBack()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            calScore(){//算正确分数 总分40
                var score=0
                this.correctNum=0
                if(this.form.sub0==3) {score += 1;this.correctNum++}
                if(this.form.sub1==3) {score += 1;this.correctNum++}
                if(this.form.sub2==3) {score += 1;this.correctNum++}
                if(this.form.sub3==0) {score += 1;this.correctNum++}
                if(this.form.sub4==0) {score += 1;this.correctNum++}
                if(this.form.sub5==2) {score += 1;this.correctNum++}
                if(this.form.sub6==1) {score += 1;this.correctNum++}
                if(this.form.sub7==1) {score += 1;this.correctNum++}
                if(this.form.sub8==2) {score += 1;this.correctNum++}
                if(this.form.sub9==0) {score += 1;this.correctNum++}
                if(this.form.sub10==2) {score += 1;this.correctNum++}
                if(this.form.sub11==3) {score += 1;this.correctNum++}
                if(this.form.sub12==3) {score += 1;this.correctNum++}
                if(this.form.sub13==1) {score += 1;this.correctNum++}
                if(this.form.sub14==2) {score += 1;this.correctNum++}
                if(this.form.sub15==2) {score += 1;this.correctNum++}
                if(this.form.sub16==2) {score += 1;this.correctNum++}
                if(this.form.sub17==2) {score += 1;this.correctNum++}
                if(this.form.sub18==0) {score += 1;this.correctNum++}
                if(this.form.sub19==2) {score += 1;this.correctNum++}
                if(this.form.sub20==3) {score += 1;this.correctNum++}
                if(this.form.sub21==3) {score += 1;this.correctNum++}
                if(this.form.sub22==3) {score += 1;this.correctNum++}
                if(this.form.sub23==1) {score += 1;this.correctNum++}
                if(this.form.sub24==0) {score += 1;this.correctNum++}
                if(this.form.sub25==1) {score += 1;this.correctNum++}
                if(this.form.sub26==1) {score += 1;this.correctNum++}
                if(this.form.sub27==0) {score += 1;this.correctNum++}
                if(this.form.sub28==0) {score += 1;this.correctNum++}
                if(this.form.sub29==2) {score += 1;this.correctNum++}
                if(this.form.sub30==2) {score += 1;this.correctNum++}
                if(this.form.sub31==1) {score += 1;this.correctNum++}
                if(this.form.sub32==0) {score += 1;this.correctNum++}
                if(this.form.sub33==3) {score += 1;this.correctNum++}
                if(this.form.sub34==1) {score += 1;this.correctNum++}
                if(this.form.sub35==0) {score += 1;this.correctNum++}
                if(this.form.sub36==2) {score += 1;this.correctNum++}
                if(this.form.sub37==0) {score += 1;this.correctNum++}
                if(this.form.sub38==0) {score += 1;this.correctNum++}
                if(this.form.sub39==0) {score += 1;this.correctNum++}
                return score
            },
        },
        watch:{
            $route(to,from){
                console.log(from.path)
                if(to.path==='/dentalAccountingTest'){
                    this.getData()
                }
            }
        }
    }
</script>
<style scoped>
    .score{
        top:15px
    }
    .el-radio-group{
        width: 100%;
    }
    .el-radio{
        width: 100%;
        /* display: flex; */
        align-items: center;
        line-height: 20px!important;
        height: auto!important;
        display: flex;
        margin: 10px 0;
    }
    /deep/ .el-radio__label{
        white-space: normal;  /* 换行 */
    }

    /deep/ .el-checkbox__label{
        white-space: normal;  /* 换行 */
    }
    .rightPic{
        width: 20px;
        height:20px;
    }
    .review{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>